import axios from "axios";

const PrivateAPI = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

PrivateAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem("token")
  if (token) {
    config.headers.Authorization = `Token ${token}`
  }
  // For blob downloads, don't set Accept header to allow server to send binary data
  if (config.responseType === 'blob') {
    config.headers.Accept = '*/*'
    // Remove Content-Type for blob downloads
    delete config.headers['Content-Type']
  }
  // For FormData uploads, let the browser set Content-Type with boundary
  // This is important for onUploadProgress to work correctly
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type']
  }
  return config
},
  (error => Promise.reject(error)))

PrivateAPI.interceptors.response.use(response => response, error => {
  if (error?.response?.status === 401) {
      localStorage.clear()
      window.location.href = "/"
  } else {
    return Promise.reject(error)
  }
})

export default PrivateAPI